<!-- 公司信息管理 -->
<template>
  <div class="fuzzy-matching-box">
    <div class="fuzzy-matching-top">
      <!-- <h1 class="titleStyle">公司信息管理</h1> -->
      <el-row class="top-first-line the-second-line">
        <el-col :span="8">
          <el-form-item label="公司标识:">
            <el-input v-model="Dform.username" placeholder=''></el-input>
          </el-form-item>
        </el-col >
        <el-button type="primary" size="medium" class="query-button" @click="inquiryClick">查询</el-button>
        <el-button type="primary" size="medium" class="query-button" @click="Addclickxinxi">新增公司信息</el-button>
        <el-button type="primary" size="medium" class="query-button" @click="entrylogClick">修改公司信息</el-button>
          
      </el-row>
    </div>
    <div class="fuzzy-matching-bottom">
      <el-row class="list">
         <el-table
         stripe
        :border="true"
         class="table-Style"
         v-loading="loading"
         :header-cell-style="{background:'#EDF6FF',color:'#000',}"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column
            prop="companyId"
            label="标识"
            >
          </el-table-column>
          <el-table-column
            prop="userName"
            label="用户名称"
            >
          </el-table-column>
          <el-table-column
          prop="strUrl"
          label='请求域名'
          >
          </el-table-column>
          <el-table-column
          show-overflow-tooltip
            prop="publicKey"
            label="公钥"
            >
          </el-table-column>
          <el-table-column
          show-overflow-tooltip
            prop="privateKey"
            label="私钥"
            >
          </el-table-column> 
        </el-table>

        <div class="block-fenye" >
          <el-pagination
              :small="small"
              :disabled="disabled"
              :background="background"
              layout="prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
        </div>
      </el-row>

    </div>
    <Addxinxi v-if="showAdd" @backShow="backShow"></Addxinxi>
  </div>
</template>

<script>
  import { companyInfoManagement } from '@/assets/api/logapi'
  import Addxinxi from './addxinxi/Add.vue'
export default {
  components: {
    Addxinxi
  },
  data() {
      return {
        showAdd:false,
        loading:true,
        Dform:{
          username:''
        },
        tableData: [],
        pageInfo: {
          page: 1,
          pageSize: 10,
        },
        total: 0
      };
  },
  created() {
    this.companyInfoManagementClick()
  },
  mounted() {

  },
  methods: {
    //新增
    Addclickxinxi(){
   
    this.showAdd=true
  },
    backShow(){
      this.showAdd = false
      this.companyInfoManagementClick()
    },
    inquiryClick( ) {
      this.pageInfo.page = 1
      this.total = 0
      this.companyInfoManagementClick()
    },
    companyInfoManagementClick () {
      let params = {
        companyId: this.Dform.username,
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
      }
      companyInfoManagement(params).then((res)=> {
        this.tableData = res.data.data.list
        this.total = res.data.data.total
        console.log(this.tableData,res,'公司信息管理--接口');
        this.loading = false
      }).catch((err)=> {
          console.log(err);
      })
    },
    handleCurrentChange (val) {
      this.pageInfo.page = val
      this.companyInfoManagementClick()  
    },
  },
};
</script>

<style scoped lang="scss">
  .fuzzy-matching-box {
        width: 100%;
        height:  96%;
        .fuzzy-matching-top {
          height: 100px ;
          background-color: #fff;
          border-radius: 15px;
          display: flex;
          align-content: space-around;  
          align-items: center;
          .titleStyle{
            margin-left: 40px;
            font-size: 20px;
            font-weight: 700;
            width: 50%;

          }
      /deep/ {
        .el-input--small .el-input__wrapper{

              width: 150px ;
              margin-right: 15px;
              border-radius: 15px
              ;
            }
  
        .el-form-item--small .el-form-item__label {
          width: 110px;
          text-align: right;
          height: 35px;
          line-height: 35px;      
          font-size: 16px;
          font-weight: 700;

        }
        .el-input {
          width:170px;
          height: 35px;
        }
        .query-button{
          margin-left: 50px;
          // background-color: #1BC896;
          border-radius: 15px;
          }
    }
    .the-second-line {
      margin-top: 15px;
      position: relative;
    }
   
  }
  .fuzzy-matching-bottom {
    height: 87%;
    overflow: auto;
    position: relative;
    padding: 0px 20px;
    padding-top: 30px;
    margin-top: 15px;
    background-color: #fff;
    border-radius: 15px;
      .table-Style{
        font-size: 16px;
        // border-radius: 15px;
      }
    .top-first-line {
      height: 45px;
      line-height: 45px;
        /deep/ .tip-button {
          padding: 14px 14px;
          margin: 0px 3px;
        }
      .import-export-button {
        position: absolute;
        right: 20px;
        /deep/ .el-button--small {
          padding: 16px 24px;
          border: 1px solid #569CFF;
          color: #569CFF;
        }
      }
    }
    .list {
      position: relative;
      // margin-top: 10px;
      padding-bottom: 50px;
     .fenye {
      // float: right;
      text-align: center;
     }
      /deep/ {
        // .el-checkbox.el-checkbox--small .el-checkbox__inner {
        //   width: 18px;
        //   height: 18px;
        // }
        // .el-checkbox:last-of-type {
        //   margin-right: -1px;
        // }
        .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
          // border: 0px;
        }
        .el-table tr {
          height: 40px;
          cursor: pointer;
          // user-select: none;
          font-size: 16px;
          color: black;
        }
         .manipulate {
          color: red;
          margin-right:15px;
          // cursor: pointer;
          // user-select: none;
        }
        .confirm,.duplicate,.revise {
          color:#1677FF;
          
        }
        .el-table th.el-table__cell>.cell {
          text-align: center;
          font-weight: 700;
        }
        .el-table td.el-table__cell, .fuzzy-matching-box .fuzzy-matching-bottom .list[data-v-1ddf37d1] .el-table th.el-table__cell.is-leaf {
          text-align: center;
        }
      }
      .block-fenye {
        // float: right;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%,0);
        
      }
    }
  }
}
</style>
